
function CommonModal({
  isOpen,
  title,
  message,
  onClose,
  onConfirm,
  type = "info",
  confirmText = "OK",
  cancelText = "Cancel",
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-md mx-4 overflow-hidden rounded-2xl bg-white shadow-2xl">
        
        <div className="border-b px-6 py-4">
          <h2
            className={`text-lg font-semibold ${
              type === "error"
                ? "text-red-600"
                : type === "warning"
                ? "text-yellow-600"
                : "text-gray-900"
            }`}
          >
            {title}
          </h2>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm text-gray-700">{message}</p>
        </div>

        <div className="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4">
          {onConfirm && (
            <button
              onClick={onClose}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm"
            >
              {cancelText}
            </button>
          )}

          <button
            onClick={onConfirm || onClose}
            className={`rounded-lg px-4 py-2 text-sm text-white btn btn-primary`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CommonModal;